import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appScrollToError]'
})
export class ScrollToErrorDirective {

  constructor(private el: ElementRef) { }

  @HostListener('submit', ['$event'])
  onSubmit() {
    this.scrollToFirstError();
  }

  public scrollToFirstError() {
    setTimeout(() => {
      const firstInvalidControl = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid')[0];
      if (firstInvalidControl) {
        firstInvalidControl.scrollIntoView({ behavior: 'smooth' , block: 'center' });
      }
    }, 100);
  }
}
